
export const editQuestionViewLogic = (store, next, action) => {
    switch (true) {
        default:
            next(action)
            break;
    }
}
